import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getCurrentUser } from '../features/auth/authSlice';
import { needsEmailVerification } from '../utils/authVerification';

/**
 * Component that handles root path redirect based on authentication status
 * - If logged in → redirect to /dashboard
 * - If not logged in → redirect to /login
 */
const RootRedirect = () => {
  console.log('RootRedirect rendering...');
  const dispatch = useDispatch();
  const { user, token, mustChangePassword, status } = useSelector((state) => state.auth);

  console.log('Auth state:', { user, token, status });

  useEffect(() => {
    console.log('RootRedirect useEffect running...');
    // If we have a token but no user, try to get current user
    if (token && !user && status === 'idle') {
      console.log('Fetching current user...');
      dispatch(getCurrentUser()).catch((error) => {
        console.error('Failed to get current user:', error);
      });
    }
  }, [token, user, status, dispatch]);

  // Show loading state while checking auth
  if (token && !user && status === 'loading') {
    console.log('Showing loading state...');
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (user && token) {
    const mustSetupPassword =
      mustChangePassword ||
      localStorage.getItem('auth_must_change_password') === 'true';
    if (mustSetupPassword) {
      return <Navigate to="/auth/complete-invited-password-setup" replace />;
    }
    const mustVerify =
      localStorage.getItem('auth_verification_required') === 'true' ||
      needsEmailVerification(user);
    return <Navigate to={mustVerify ? '/verify-email' : '/dashboard'} replace />;
  }

  const storedToken = localStorage.getItem('auth_token');
  if (storedToken && localStorage.getItem('auth_must_change_password') === 'true') {
    return <Navigate to="/auth/complete-invited-password-setup" replace />;
  }
  if (storedToken && localStorage.getItem('auth_verification_required') === 'true') {
    return <Navigate to="/verify-email" replace />;
  }

  // If not logged in, redirect to login
  console.log('User not logged in, redirecting to login...');
  return <Navigate to="/login" replace />;
};

export default RootRedirect;

